export default __webpack_public_path__ + "static/media/outside.7d1988ff.png";